import FilledButtonM from "@common/components/button/FilledButtonM"
import TextM from "@common/components/text/TextM"
import { ModalM } from "@common/components/modal/ModalM"
import { theme } from "@common/theme/theme"
import { IS_WEB } from "@common/utils/mobileUtils"
import * as WebBrowser from "expo-web-browser"
import React from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

const PaymentBlockedModal = ({ visible, onDismiss, paymentUrl }) => {
    const openPaymentLink = () => {
        if (!paymentUrl) return
        if (IS_WEB) {
            window.open(paymentUrl, "_blank")
        } else {
            WebBrowser.openBrowserAsync(paymentUrl)
        }
        onDismiss()
    }

    return (
        <ModalM
            visible={visible}
            onDismiss={onDismiss}
            dismissable
            withExitButton
            style={{ maxWidth: 420 }}
        >
            <View style={{ padding: 10, paddingTop: 20, alignItems: "center" }}>
                <FontAwesome5
                    name="lock"
                    solid
                    size={52}
                    color={theme.colors.warning}
                    style={{ marginBottom: 20 }}
                />
                <TextM
                    fontWeight="Bold"
                    fontSize={18}
                    color={theme.colors.primary}
                    wrap
                    style={{ marginBottom: 12, textAlign: "center" }}
                >
                    Ton abonnement n'a pas été payé !
                </TextM>
                <TextM
                    fontWeight="Regular"
                    fontSize={14}
                    color={theme.colors.grey}
                    wrap
                    style={{ textAlign: "center", marginBottom: 24 }}
                >
                    Pour retrouver l'accès aux sessions LIVE, le paiement de
                    l'abonnement doit être régularisé.
                </TextM>
                <FilledButtonM
                    label="Régulariser le paiement"
                    icon="external-link-alt"
                    onPress={openPaymentLink}
                    color={theme.colors.primary}
                    style={{ width: "100%", marginBottom: 10 }}
                />
                <FilledButtonM
                    label="Fermer"
                    mode="outlined"
                    onPress={onDismiss}
                    color={theme.colors.grey}
                    style={{ width: "100%" }}
                />
            </View>
        </ModalM>
    )
}

export default PaymentBlockedModal
